import { AnswerStatus } from "@/models/enum/answerStatus";
import { ForwardingStatus } from "@/models/enum/forwardingStatus";

export default class ReceivedQuestionnaire {
  tlcName? = "";
  questionnaireId = "";
  questionnaireLabel = "";
  contextId = "";
  emailSent = 0;
  answerStatus = AnswerStatus.NotStarted;
  forwardingStatus = ForwardingStatus.NotStarted;
  receiverCompanyAlias = "";
  senderCompanies = new Array<string>();
  isBusinessPartner = false;
  templateId = "";
  senderEmails = new Array<string>();
  lastEdited = "";
}
